module.exports = __webpack_public_path__ + "img/sm-facebook.d6ffd03c.svg";